// extracted by mini-css-extract-plugin
export default {"documents":"document_documents__5dQ26","documentsSpinner":"document_documentsSpinner__wq89H"};